const handleModalState = (
  state: string,
  setModalState: (state: string) => void
) => {
  setModalState(state);
};

export default handleModalState;
